module.exports = __webpack_public_path__ + "img/abou-2.ecb9fb27.jpg";